import axios from 'axios'
import Qs from 'qs'
import Vue from 'vue'
var hrraxios = {}
hrraxios.install = function(Vue) {
  if (hrraxios.installed) {
    return
  }
  var instance = axios.create({
    //baseURL:'http://192.168.0.107',
    //baseURL:'http://180.167.29.132:38003',
    //baseURL:'http://localhost:50101',
    //baseURL:'http://172.31.1.104:8011',
    baseURL: '', //发布的
    withCredentials: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    },
    //headers:{'Content-Type':'application/json'},
    paramsSerializer: function(params) {
      return Qs.stringify(params, {
        indices: false,
        arrayFormat: 'indices',
        allowDots: true,
      })
      //return JSON.stringify(params);
    },
  })
  //请求拦截器
  instance.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      config.data = Qs.stringify(config.data, {
        indices: false,
        arrayFormat: 'indices',
        allowDots: true,
      }) //参数序列化
      var token = sessionStorage.getItem('access_token')
      if (token != null) {
        config.headers.Authorization = 'BasicAuth ' + token
      }
      return config
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  //响应拦截器
  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      // console.log(response.config.url);
      if (response.data.Login == false) {
        Vue.prototype
          .$confirm(response.data.Prompt, '提示', {
            closeOnClickModal: false,
            showCancelButton: false,
            showClose: false,
            type: 'warning',
            center: true,
          })
          .then(() => {
            location.href = '/'
          })
      }
      return response
    },
    function(error) {
      // Do something with response error
      return Promise.reject(error)
    }
  )
  Vue.prototype.$hrraxios = instance
  Vue.prototype.axios = axios
  Vue.prototype.$axios = axios //组件暴露原生asios
  Vue.prototype.$Qs = Qs //组件暴露Qs
  hrraxios.installed = true
}
export default hrraxios
